import { render } from "./DataFetcher.vue?vue&type=template&id=76da4311"
import script from "./DataFetcher.vue?vue&type=script&lang=js"
export * from "./DataFetcher.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__